import { HELP_PANEL_TABBABLE_SELECTOR } from "@/constants/help";

/**
 * Where a forward Tab must wrap to when focus sits on a non-tabbable element inside `panel` (a view
 * heading that took focus after in-panel navigation) and nothing tabbable follows it. useFocusTrap
 * only wraps from its last tabbable, so without this the Tab would walk out of the dialog. Null
 * when the browser's own Tab order already stays inside.
 */
export function helpPanelTabWrapTarget(
  panel: HTMLElement,
  current: Element | null,
): HTMLElement | null {
  if (!(current instanceof HTMLElement) || current === panel || current.tabIndex >= 0) return null;
  if (!panel.contains(current)) return null;
  const tabbable = Array.from(
    panel.querySelectorAll<HTMLElement>(HELP_PANEL_TABBABLE_SELECTOR),
  ).filter((el) => el.offsetParent !== null);
  const hasNext = tabbable.some(
    (el) => (current.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0,
  );
  return hasNext ? null : (tabbable[0] ?? null);
}
